import { GetterTree } from 'vuex'
import { ProductState } from './product.types'
import { ProductImage, VariantImage } from '../../types'

export const getters: GetterTree<ProductState, unknown> = {
  images(state) {
    // Make sure the front_page image is first in the array.
    // If front_page is undefined, default it to false
    return state.images.sort((a, b) => Number(b.image.front_page || false) - Number(a.image.front_page || false))
  },
  // Active images that do not belong to inactive variants
  activeImages(state, getters) {
    const inactiveVariants = state.variants.filter(v => v.deactivatedAt)
    return getters.images.filter(
      ({ image }: ProductImage) =>
        // Filter out archived images
        !image.is_archived &&
        // Filter out images belonging to inactive variants
        !inactiveVariants.find(v =>
          ((v.images as Array<VariantImage>) || []).some((img: VariantImage) => img._id === image._id)
        )
    )
  },
  imagesLoadingError(state) {
    return state.imagesLoadingError
  },
  sizes(state) {
    return state.sizes
  },
  sizesLoadingError(state) {
    return state.sizesLoadingError
  },
  allVariants(state) {
    return state.variants
  },
  variants(state) {
    if (state.variantsFilter === 'Active') return state.variants.filter(variant => !variant.deactivatedAt)
    if (state.variantsFilter === 'Inactive') return state.variants.filter(variant => !!variant.deactivatedAt)
    return state.variants
  },
  variantsFilter(state) {
    return state.variantsFilter
  },
  variantsLoadingError(state) {
    return state.variantsLoadingError
  },
  queryObject(state) {
    return state.queryObject
  }
}
